export const CLEAR_COLLECTIONS = 'collections/clear_collections';
export const SET_COLLECTIONS = 'collections/set_collections';
export const UPDATE_COLLECTION = 'collections/update_collection';
export const BROWSE_EVENTS = 'collections/browse_events';
